<div class="header">
  <div class="header-container">
   <app-org-logo></app-org-logo>
   <ion-label>{{tabTitle}}</ion-label>
   </div>

 </div>

<div class="dashboard-container">
 
 <app-spinner *ngIf="isLoading"></app-spinner>
 <div *ngIf="routeOption==='dashboard1'">
  <iframe title="STEP-Final_V2" width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiYmFiNWU5ZWEtNzQyYS00OTBkLWIzODItNTNlYjBmZjlhYTRlIiwidCI6IjNjY2ZhZTM4LWE1OGUtNGVkZS05M2QwLTEwMmQ2ZDE3OWM1OSJ9&pageName=bbf7dd8707eb431d15e9" frameborder="0" allowFullScreen="true"  (load)="onIframeLoad()"></iframe>
 </div>
 <div *ngIf="routeOption==='dashboard2'">
  <iframe title="STEP-Final_V2" width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiY2MxZWE2YWEtNTRjOS00ZTFhLWIyMDgtMzA2MTQ5OGJjZmUyIiwidCI6IjNjY2ZhZTM4LWE1OGUtNGVkZS05M2QwLTEwMmQ2ZDE3OWM1OSJ9&pageName=bbf7dd8707eb431d15e9" frameborder="0" allowFullScreen="true"  (load)="onIframeLoad()"></iframe>
 </div>
 <div *ngIf="routeOption==='insights'">
  <iframe title="STEP-Final_V2" width="600" height="373.5" src="https://zapcom-app-90052637893.us-central1.run.app/" frameborder="0" allowFullScreen="true"  (load)="onIframeLoad()"></iframe>
 </div>
 <div *ngIf="routeOption==='word-cloud'">
  <iframe title="STEP-Final_V2" width="600" height="373.5" src="https://word-count-90052637893.us-central1.run.app/" frameborder="0" allowFullScreen="true"  (load)="onIframeLoad()"></iframe>
 </div>
 
</div>
